import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Pane, Paneset } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import BarcodePatternsForm from './components/BarcodePatternsForm';

function BarcodePatternsSettings(props) {
  const [initialValues, setInitialValues] = useState({
    patternValues: [
      'campusCode',
      'libraryCode',
      'locationCode',
      'yearCode',
      'monthCode',
      'dayCode',
      'serialNo',
    ],
  });
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const onHandleSubmit = (values) => {};

  return (
    <BarcodePatternsForm
      onHandleSubmit={onHandleSubmit}
      initialValues={initialValues}
      isLoading={false}
    />
  );
}

BarcodePatternsSettings.propTypes = {};

export default BarcodePatternsSettings;
